module.exports = __webpack_public_path__ + "assets/img/tr.12e3752e.jpg";